/* eslint-disable no-console */
import React, { Component } from "react";
import { Formik } from "formik";
import emailjs from "emailjs-com";
import * as yup from "yup";
import { Animated } from "react-animated-css";
import { Container, Row, Col, Jumbotron } from "reactstrap";
import CommentInput from "./CommentInput";
import TextInput from "./TextInput";

class Apply extends Component {
  render() {
    return (
      <div>
        <Container>
          <Row>
            <Col xs="3" />
            <Col />
            <Col xs="auto">
              <Formik
                initialValues={{
                  firstName: "",
                  middleName: "",
                  lastName: "",
                  phone: "",
                  email: "",
                  confirmEmail: "",
                  comments: "",
                }}
                validationSchema={yup.object().shape({
                  firstName: yup
                    .string()
                    .required("Your First Name Is Required!")
                    .min(2, "Your First Name Needs To Be Valid"),
                  lastName: yup
                    .string()
                    .required("Your Last Name Is Required!")
                    .min(2, "Your Last Name Needs To Be Valid"),
                  phone: yup
                    .number()
                    .required("Your Telephone Number Is Required!")
                    .positive(),
                  email: yup
                    .string()
                    .email()
                    .required("Your Email Is Required!"),
                  confirmEmail: yup
                    .string()
                    .email()
                    .required("Your Confirm Email Is Required!")
                    .oneOf([yup.ref("email", undefined)], "Make Sure Emails Match!"),
                })}
                onSubmit={(values, actions) => {
                  setTimeout(() => {
                    const templateParams = {
                      firstName: values.firstName,
                      middleName: values.middleName,
                      lastName: values.lastName,
                      confirmEmail: values.confirmEmail,
                      comments: values.comments,
                      phone: values.phone,
                    };

                    emailjs
                      .send(
                        "default_service",
                        "template_rx8wkrg",
                        templateParams,
                        "user_gXlSTj23Wi3kkFk1IRtXo"
                      )
                      .then(
                        result => {
                          console.log(result.text);
                        },
                        error => {
                          console.log(error.text);
                        }
                      );
                    actions.setSubmitting(false);
                  });
                }}
                render={({
                  isSubmitting,
                  handleSubmit,
                  values,
                  handleChange,
                  errors,
                  touched,
                  handleBlur,
                  dirty,
                  handleReset,
                }) => (
                  <Animated
                    animationInDelay={0}
                    animationIn="slideInUp"
                    animationOut="slideOutDown"
                    isVisible
                  >
                    <Jumbotron>
                      <div className="mn p-a700">
                        <div className="b b-c p-a700">
                          <div className="str">
                            <div className="str-c">
                              <div className="str-t">Email Us</div>
                            </div>
                          </div>

                          <div className="b b-c p-a700"></div>
                          <form action="/send" method="post" onSubmit={handleSubmit} on>
                            <div className="g">
                              <div className="sel">
                                <label className="txt-l txt-l--sm">Prefix </label>
                                <div
                                  className="sel-c sel-c--thin"
                                  style={{
                                    marginRight: 14,
                                  }}
                                >
                                  <select className="sel-f sel-f--thin">
                                    <option>Mr</option>
                                    <option>Mrs</option>
                                    <option>Miss</option>
                                    <option>Mx</option>
                                  </select>
                                </div>
                              </div>
                              <div className="g--3 m-b300">
                                <TextInput
                                  title="First Name"
                                  name="firstName"
                                  placeholder="First Name"
                                  value={values.firstName}
                                  onChange={handleChange}
                                  error={touched.firstName && errors.firstName}
                                  onBlur={handleBlur}
                                  required
                                />
                              </div>
                              <div className="g--1 m-b300">
                                <TextInput
                                  title="Initial"
                                  name="middleName"
                                  placeholder="Middle Initial"
                                  value={values.middleName}
                                  onChange={handleChange}
                                  error={touched.middleName && errors.middleName}
                                  onBlur={handleBlur}
                                />
                              </div>
                              <div className="g--6 m-b300">
                                <TextInput
                                  title="Last Name"
                                  name="lastName"
                                  placeholder="Last Name"
                                  value={values.lastName}
                                  onChange={handleChange}
                                  error={touched.lastName && errors.lastName}
                                  onBlur={handleBlur}
                                  required
                                />
                              </div>
                            </div>

                            <TextInput
                              title="Phone"
                              name="phone"
                              placeholder="Phone Number"
                              value={values.phone}
                              onChange={handleChange}
                              error={touched.phone && errors.phone}
                              onBlur={handleBlur}
                            />
                            <TextInput
                              title="Email"
                              name="email"
                              placeholder="Email"
                              value={values.email}
                              onChange={handleChange}
                              error={touched.email && errors.email}
                              required
                              onBlur={handleBlur}
                            />
                            <TextInput
                              title="Confirm Email"
                              name="confirmEmail"
                              placeholder="Confirm Email"
                              value={values.confirmEmail}
                              onChange={handleChange}
                              error={touched.confirmEmail && errors.confirmEmail}
                              onBlur={handleBlur}
                              required
                            />
                            <hr className="hr hr--sq" />
                            <p className="ta-c p-h200 t--intro">
                              Please note it might take 1 day to respond back. Please
                              still fill this form out and I will get back to you ASAP!
                            </p>

                            <hr className="hr hr--sq" />
                            <CommentInput
                              name="comments"
                              placeholder="Other Comments You Would Like Us to Know."
                              value={values.comments}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <div className="b">
                              <div className="m-v400 m-h200">
                                <button
                                  disabled={!dirty || isSubmitting}
                                  onClick={values.handleSubmit}
                                  type="submit"
                                  className="btn btn--c btn--br"
                                >
                                  Send Message
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Jumbotron>
                  </Animated>
                )}
              />
            </Col>
            <Col xs="3" />
          </Row>
        </Container>
      </div>
    );
  }
}

export default Apply;
